import { render } from "./Products.vue?vue&type=template&id=7ac11638"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nakarinjaiseengam/Works/Electroic-demo/STM-POS/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__